import * as React from 'react';
import Typography from '@material-ui/core/Typography';
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles,
} from '@material-ui/core/styles';
import { Button, Card, CardActionArea, CardContent, CardMedia, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { DeltaJSONColors, DeltaXMLColors } from '../styling/DeltaColors';

const styles = (theme: Theme) =>
  createStyles({
    cardRoot: {
      display: 'flex',
      margin: '5px',
      maxHeight: '75px'
    },
    cardDetails: {
      display: 'flex',
      flexDirection: 'column',
    },
    cardContent: {
      flex: '1 0 auto',
    },
    cardCover: {
      width: 245,
    },
    title: {
      color: DeltaJSONColors.BREAKER_BAY,
    },
  });


export interface VideoDialogProps extends WithStyles<typeof styles> { 
    videoHeading: string,
    videoURL: string,
    videoThumbnail: string,
}

function VideoDialog(props: VideoDialogProps) {
    const { classes, videoHeading, videoURL, videoThumbnail } = props;

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
      setOpen(false);
    }

    return (
        <>
        <CardActionArea onClick={handleClickOpen}>
            <Card className={classes.cardRoot}>
                <div className={classes.cardDetails}>
                    <CardContent className={classes.cardContent}>
                    <Typography className={classes.title} style={{width: '35px'}} variant="body2" color="primary">
                        {videoHeading}
                    </Typography>
                    </CardContent>
                </div>
                <CardMedia
                    className={classes.cardCover}
                    image={videoThumbnail}
                />
            </Card>
        </CardActionArea>
        <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" maxWidth="lg" open={open}>
            <DialogTitle style={{backgroundColor: DeltaXMLColors.OXFORD_BLUE, color: DeltaXMLColors.CELERY}}>
            {videoHeading}
            </DialogTitle>
            <DialogContent dividers>
            <iframe
                    id="video"
                    title="video"
                    width="854"
                    height="480"
                    src={videoURL}
                    frameBorder="0"
                    allow="accelerometer, autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    />
            </DialogContent>
            <DialogActions>
            <Button autoFocus onClick={handleClose} color="primary" variant="contained">
                Close
            </Button>
            </DialogActions>
        </Dialog>
        </>
    );
}

export default withStyles(styles)(VideoDialog);